export const DIAL_LIST_ENTRY_STATUSES = [
    'pending',
    'in_progress',
    'reached',
    'no_answer',
    'voicemail',
    'rejected',
    'wrong_number',
    'do_not_call',
    'skipped'
];
/** Statuses that count as "done" — no further retry expected. */
export const TERMINAL_DIAL_STATUSES = [
    'reached',
    'wrong_number',
    'do_not_call'
];
//# sourceMappingURL=dial-list.js.map